import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

import { Close } from '@aok/icon-functional'

import SearchAutocomplete from '../../molecules/SearchAutocomplete/SearchAutocomplete'

import { handleAutocompleteRequest } from '../../../utils/requests/handleAutocompleteRequest'
import { getEnvironment } from '../../../utils/appUtils'
import { APIContext } from '../../../context/APIContext'
import { openUrl } from '../../../utils/UrlUtils'
import { withPrefix } from 'gatsby-link'

const DesktopSearch = ({ onSubmitSearch, onCloseButtonClick }) => {
  const apiContext = useContext(APIContext)
  const [api] = useState({
    autocompleteUrl: apiContext[getEnvironment('AUTOCOMPLETE_URL') || ''],
    frequentlySearchedUrl: apiContext[getEnvironment('FREQUENTLY_SEARCHED_URL') || ''],
  })
  const handleRequestAutocompleteData = (query, successCallback) => {
    handleAutocompleteRequest(api.autocompleteUrl, query, successCallback)
  }

  const submitSearch = (value) => {
    if (!value) {
      return
    }

    let searchParams = new URLSearchParams()
    searchParams.set('q', encodeURIComponent(value))
    const completeUrl = withPrefix(`/suche/?${searchParams.toString()}`)
    openUrl(completeUrl)

    onSubmitSearch()
  }

  return (
    <div className="shadow-header">
      <div
        className="pt-24 pb-80
          mx-24 1000:mx-32 1280:w-1216 1280:mx-auto
          border-t-2 border-dfe3e6"
      >
        {/* Close button */}
        <button className="block ml-auto mr-0" onClick={onCloseButtonClick}>
          <span className="sr-only">Ausgeklapptes Suchfenster schließen</span>
          <Close className="w-20 h-20 fill-current text-005e3f transition-transform duration-350 ease-in hover:scale-120" />
        </button>

        <div className="mt-32 grid grid-cols-12 gap-24 1000:gap-32">
          <SearchAutocomplete
            className="col-start-3 col-end-11"
            autocompleteProps={{
              variant: 'light',
            }}
            searchFieldProps={{
              id: 'mobile-header-searchField-input',
              label: 'Wonach suchen Sie?',
              labelVisibility: 'show',
              inputProps: {
                placeholder: 'z.B. Gesunde Ernährung',
              },
              variant: 'light',
            }}
            onSubmit={submitSearch}
            onSelect={submitSearch}
            onRequestAutocompleteData={handleRequestAutocompleteData}
          />
        </div>
      </div>
    </div>
  )
}

DesktopSearch.propTypes = {
  onSubmitSearch: PropTypes.func,
  onCloseButtonClick: PropTypes.func,
}

DesktopSearch.defaultProps = {
  onSubmitSearch: () => {},
  onCloseButtonClick: () => {},
}

export default DesktopSearch
